<template>
    
    <div class="site-layout">

        <site-search
            @handleAdd="handleAdd"
            @handleSearch="handleSearch"
            :title ="title"
            :role  ="role"
            :group ="group"
            :place ="place"
            :search="search"
        ></site-search>


        <site-data-table
            @handleSearch="handleSearch"
            :loading="loading"
            :columns="columns"
            :data   ="data"
            :total  ="total"
            :search ="search"
        >
            <template v-slot:action="action">
                <v-row justify="start">

                    <v-icon color="primary" small @click="handleRefurbish(action.value.item)">loop</v-icon>
                    <span class="table-btn-span" @click="handleRefurbish(action.value.item)">
                        {{ $vuetify.lang.t('$vuetify.userManage.site.refurbishBtn') }}
                    </span>

                    <div class="mx-1"></div>

                    <v-icon color="primary" small @click="handleEidt(action.value.item)">edit</v-icon>
                    <span class="table-btn-span" @click="handleEidt(action.value.item)">
                        {{ $vuetify.lang.t('$vuetify.userManage.editBtn') }}
                    </span>

                    <div class="mx-1"></div>

                    <v-icon color="primary" small @click="handleDelete(action.value.item)">delete</v-icon>
                    <span class="table-btn-span" @click="handleDelete(action.value.item)">
                        {{ $vuetify.lang.t('$vuetify.userManage.deleteBtn') }}
                    </span>

                </v-row>
            </template>
        </site-data-table>

        <add-site 
            ref="add"
            :role="role" 
            :group="group" 
            :place="place" 
            @handleSearch="handleSearch"
        ></add-site>

        <edit-site 
            ref="edit"
            :role="role" 
            :place="place" 
            @handleSearch="handleSearch"
        ></edit-site>

        <del-site ref="del" @handleSearch="handleSearch"></del-site>
        <refurbish-key-site ref="refurbish" @handleSearch="handleSearch"></refurbish-key-site>

    </div>

</template>

<script>
import * as api from '../../api'
import SiteSearch from './components/SiteSearch.vue'
import SiteDataTable from './components/SiteDataTable.vue'
import AddSite from './components/AddSite.vue'
import EditSite from './components/EditSite.vue'
import DelSite from './components/DelSite.vue'
import RefurbishKeySite from './components/RefurbishKeySite.vue'

export default {

    components: {
        SiteSearch,
        SiteDataTable,
        AddSite,
        EditSite,
        DelSite,
        RefurbishKeySite,
    },

    data () {
      return {

            role: parseInt(window.sessionStorage.getItem('type')),

            title: this.$vuetify.lang.t('$vuetify.userManage.site.title'),

            group: [],
            place: [],

            columns: [
                {
                    text : this.$vuetify.lang.t('$vuetify.userManage.site.table.name'),
                    sortable: false,
                    value: 'name'
                },
                {
                    text : this.$vuetify.lang.t('$vuetify.userManage.site.table.contact'),
                    sortable: false,
                    value: 'contact'
                },
                {
                    text : this.$vuetify.lang.t('$vuetify.userManage.site.table.groupName'),
                    sortable: false,
                    value: 'groupName'
                },
                {
                  text : this.$vuetify.lang.t('$vuetify.userManage.site.table.shopTypeName'),
                  sortable: false,
                  value: 'shopTypeName'
                },
                {
                    text : this.$vuetify.lang.t('$vuetify.userManage.site.table.areaName'),
                    sortable: false,
                    value: 'area'
                },
                {
                    text : this.$vuetify.lang.t('$vuetify.userManage.site.table.key'),
                    sortable: false,
                    value: 'bindkey'
                },
                {
                    text : this.$vuetify.lang.t('$vuetify.userManage.site.table.action'),
                    sortable: false,
                    value: 'action'
                },
            ],

            data: [],

            loading: false,
            total  : 0,

            search: {
                pagesize : 10,
                pagenum  : 1,
                provincecode: null,
                citycode : null,
                areacode : null,
                groupID  : null,
                name     : null,
                contact  : null,
            }
          
      }
    },

    created () {
        this.initialize()
    },

    methods: {

        initialize() {
            this.getData();
            this.getPlace();
            this.getGroup();
        },

        getPlace () {
            this.$http.post(api.default.system.placeListUrl).then(resp => {
                // 此处都是处理正确获取后台数据的情况， 错误的情况都已经在http内部处理
                if (!resp) return;
                this.place = resp.data;
            })
        },

        getGroup () {
            this.$http.post(api.default.rbac.groupListUrl).then(resp => {
                // 此处都是处理正确获取后台数据的情况， 错误的情况都已经在http内部处理
                if (!resp) return;
                this.group = resp.data;
            })
        },

        getData () {
            this.loading = true;
            this.$http.post(api.default.rbac.shopListUrl, this.search).then(resp => {
                // 此处都是处理正确获取后台数据的情况， 错误的情况都已经在http内部处理
                if (!resp) return;
                this.total = parseInt(resp.data.total);
                this.data  = resp.data.list;
            }).finally(resp => {
                this.loading = false;
            })
        },

        handleAdd () {
            this.$refs.add.handleOpen();
        },

        handleEidt (item) {
            this.$refs.edit.handleOpen(item);
        },

        handleDelete (item) {
            this.$refs.del.handleOpen(item);
        },

        handleSearch () {
            this.getData();
        },

        handleRefurbish (item) {
            this.$refs.refurbish.handleOpen(item);
        }

    }
}
</script>

<style scoped>

.site-layout {
    margin: 0 10px;
}

.table-btn-span {
    color: #1976d2;
    cursor: pointer;
}

</style>